import { SVGProps } from "react";

/**
 * 아래 방향 chevron (드롭다운/선택 트리거용) — Figma filled glyph (24px optical).
 * fill=currentColor 라 부모 color 로 색을 제어한다 (라이트/다크 자동 대응).
 * 16px 아코디언용 넓은 변형은 ChevronDownSmallIcon 참조.
 */
const ChevronDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M11.6633 14.6198C11.5594 14.5813 11.4607 14.5153 11.367 14.4218L6.87276 9.9275C6.73442 9.789 6.66359 9.61492 6.66026 9.40525C6.65709 9.19575 6.72792 9.0185 6.87276 8.8735C7.01776 8.72867 7.19342 8.65625 7.39976 8.65625C7.60609 8.65625 7.78176 8.72867 7.92676 8.8735L11.9998 12.9468L16.0728 8.8735C16.2113 8.73517 16.3853 8.66433 16.595 8.661C16.8045 8.65783 16.9818 8.72867 17.1268 8.8735C17.2716 9.0185 17.344 9.19417 17.344 9.4005C17.344 9.60683 17.2716 9.7825 17.1268 9.9275L12.6325 14.4218C12.5388 14.5153 12.4401 14.5813 12.3363 14.6198C12.2324 14.6583 12.1203 14.6775 11.9998 14.6775C11.8793 14.6775 11.7671 14.6583 11.6633 14.6198Z"
      fill="currentColor"
    />
  </svg>
);

export default ChevronDownIcon;
